<template>
  <div style="height:100%">
    <el-row class="title-bar" style="height:31px">
      <el-input v-model="mibFileName" :readonly="true" class="mr-r4" />
      <el-button size="small" type="primary" @click="openPopup('mibFileSettingPopup')" style="height:28px;margin-top:1px">불러오기</el-button>
    </el-row>
    <el-tree ref="tree" class="tree-w-stroke obj-tree" :load="loadNode" lazy :props="props" node-key="name" :expand-on-click-node="false"
    highlight-current @node-click="clickNode" style="border:1px solid #EBEEF5;padding:5px;height:calc(100% - 319px);overflow:auto" />
    <el-row style="border:1px solid #EBEEF5;padding:1px 5px 5px 5px;margin-top:10px;height:257px;overflow:auto">
      <el-form :model="selectedNodeData.oidInfoVo" label-position="right" label-width="40px">
        <el-form-item label="OID">{{ selectedNodeData.oidInfoVo.OID ? selectedNodeData.oidInfoVo.OID : '-' }}</el-form-item>
        <el-form-item label="이름">{{ selectedNodeData.oidInfoVo.name ? selectedNodeData.oidInfoVo.name : '-' }}</el-form-item>
        <el-form-item label="타입">{{ selectedNodeData.oidInfoVo.syntax ? selectedNodeData.oidInfoVo.syntax : '-' }}</el-form-item>
        <el-form-item label="권한">{{ selectedNodeData.oidInfoVo.access ? selectedNodeData.oidInfoVo.access : '-' }}</el-form-item>
        <el-form-item label="상태">{{ selectedNodeData.oidInfoVo.status ? selectedNodeData.oidInfoVo.status : '-' }}</el-form-item>
        <el-form-item label="설명">
          <el-input type="textarea" readonly :rows="4" resize="none" v-model="selectedNodeData.oidInfoVo.description"/>
        </el-form-item>
      </el-form>
    </el-row>
    <w-mib-file-setting-popup ref="mibFileSettingPopup" @close-popup="closePopup"></w-mib-file-setting-popup>
  </div>
</template>

<script>
import { isEmpty, isEqual } from 'lodash';
import MibAPI from '@/api/mib';
import WMibFileSettingPopup from '../popup/MibFileSettingPopup';

export default {
  name: 'WMibBrowserTree',
  data() {
    return {
      isFirst: true,
      firstNode: null,
      firstResolve: null,
      selectedNodeData: {
        oidInfoVo: {},
      },
      mibFileName: null,
      props: {
        label: 'name',
        children: 'childList',
        isLeaf: 'leaf',
      },
    };
  },
  components: {
    WMibFileSettingPopup,
  },
  methods: {
    clickNode(nodeData) {
      this.selectedNodeData = nodeData;
      this.$emit('set-oid', nodeData.oidInfoVo.OID);
    },
    openPopup(popupName) {
      this.$refs[popupName].open();
    },
    closePopup(mibFileName) {
      if (!isEqual(mibFileName, this.mibFileName)) {
        this.firstNode.childNodes = [];
        this.loadNode(this.firstNode, this.firstResolve);
      }
    },
    loadNode(node, resolve) {
      if (this.isFirst) {
        this.firstNode = node;
        this.firstResolve = resolve;
        this.isFirst = false;
      }
      if (node.level === 0) {
        MibAPI.getMibTreeRoot().then((response) => {
          const result = response.data;
          if (result.success) {
            this.mibFileName = result.data[0].name;
            return resolve(result.data);
          }
          return resolve([]);
        }).catch(() => {});
      } else if (node.level === 1) {
        MibAPI.getMibTreeList(node.data.name).then((response) => {
          const result = response.data;
          if (result.success) {
            return resolve(result.data);
          }
          return resolve([]);
        }).catch(() => {
          this.$message('통신이 원할하지 않습니다.');
        });
      } else {
        const children = node.data.children;
        if (!isEmpty(children)) {
          return resolve(children);
        }
        const params = {
          mibFileName: this.mibFileName,
          fullName: node.data.oidInfoVo.fullName,
        };
        MibAPI.getMibTreeNode(params).then((response) => {
          const result = response.data;
          if (result.success) {
            return resolve(result.data);
          }
          return resolve([]);
        }).catch(() => {
          this.$message('통신이 원할하지 않습니다.');
        });
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/popup/MibBrowser/components/MibBrowserTree.vue